module.exports = __webpack_public_path__ + "static/missinganameoutline-e25e7252ac152660e72f9591d0b02a36.png";